import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import {Repository} from 'typeorm';
import {ReasonsAdapter} from './dto/reasons.adapter';
import {Reasons} from './reasons.entity';

import { ReasonsRequest } from './dto/reasons.request';
import {ReasonsDTO} from './dto/reasons.dto';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllReasonsResponse, ReasonsDropDown, ReasonsDropDownResponse, ReasonsResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';



@Injectable()
export class ReasonsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Reasons) private reasonsRepository: Repository<Reasons>,
        private ReasonsAdapter: ReasonsAdapter,
      ) { }

      async createReasons(reasonsDTO:ReasonsDTO, isUpdate: boolean,request:Request): Promise<ReasonsResponse> {
        try {
        
        if (!isUpdate) {
            const reasonsEntity = await this.getReasons(reasonsDTO.reasonCode);
          if (reasonsEntity) {
            throw new ReasonsResponse(false,11104, 'Reasons reason already exists');
          }
        }
        else{
            const reasonsEntity = await this.getReasons(reasonsDTO.reasonCode);
            if (reasonsEntity) {
                if(reasonsEntity.reasonId!=reasonsDTO.reasonId){
                    throw new ReasonsResponse(false,11104, 'Reasons reason already exists');
                }
            }
        }
        const convertedreasonsEntity:Reasons = this.ReasonsAdapter.convertDtoToEntity(reasonsDTO,isUpdate);
        const savedreasonsEntity: Reasons = await this.reasonsRepository.save(convertedreasonsEntity);
        const savedreasonsDTO: ReasonsDTO = this.ReasonsAdapter.convertEntityToDto(savedreasonsEntity);
       
         if (savedreasonsDTO) {
          const response = new ReasonsResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Reasons reason Updated Successfully':'Reasons Created Successfully',savedreasonsDTO);
          const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'Reasons', savedreasonsDTO.reasonId, true, '','')
            let res = await this.logService.createLog(newLogDto);
          return response;
        } else {
          throw new ReasonsResponse(false,11106,'Reasons saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all Reasons details  
     * @returns all the Reasons details .
     */
    // @LogActions({ isAsync: true })
    async getAllReasons(): Promise<AllReasonsResponse> {  
        try {
            const reasonsDTO: ReasonsDTO[] = [];
           
            const reasonsEntities: Reasons[] = await this.reasonsRepository.find({
                order: { reasonName: "ASC" },
            });
            
            if (reasonsEntities.length>0) {
                reasonsEntities.forEach(ReasonsEntity => {
                const convertedreasonsDTO:ReasonsDTO = this.ReasonsAdapter.convertEntityToDto(ReasonsEntity);
                reasonsDTO.push(convertedreasonsDTO);
                });
                const response = new AllReasonsResponse(true, 11208, "Reasons retrieved successfully", reasonsDTO);
                const newLogDto = new LogsDto(1,'view', 'Reasons', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                //   console.log('yest')
                throw new ReasonsResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getReasons(reasonCode: string): Promise<Reasons> {
        //  console.log(employeeId);
            const response = await this.reasonsRepository.findOne({
            where: {reasonCode: reasonCode},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value    Reasons   
     * @param itemReq     Reasons  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateReasons(reasonsReq: ReasonsRequest): Promise<ReasonsResponse> {
        try {
            const reasonsExists = await this.getReasonsById(reasonsReq.reasonId);
            if (reasonsExists) {
                if (reasonsReq.versionFlag !== reasonsExists.versionFlag) {
                    throw new ReasonsResponse(false,10113, 'Someone updated the current Reason information.Refresh and try again');
                } else {
                    
                        const reasonsStatus =  await this.reasonsRepository.update(
                            { reasonId: reasonsReq.reasonId },
                            { isActive: reasonsReq.isActive,updatedUser: reasonsReq.updatedUser });
                       
                        if (reasonsExists.isActive) {
                            if (reasonsStatus.affected) {
                                const reasonsResponse: ReasonsResponse = new ReasonsResponse(true, 10115, 'Reasonis de-activated successfully');
                                return reasonsResponse;
                            } else {
                                throw new ReasonsResponse(false,10111, 'Reason is already deactivated');
                            }
                        } else {
                            if (reasonsStatus.affected) {
                                const reasonsResponse: ReasonsResponse = new ReasonsResponse(true, 10114, 'Reasons is activated successfully');
                                return reasonsResponse;
                            } else {
                                throw new ReasonsResponse(false,10112, 'Reasons is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ReasonsResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getReasonsById(reasonId: number): Promise<Reasons> {
    //  console.log(employeeId);
        const response = await this.reasonsRepository.findOne({
        where: {reasonId: reasonId},
        });
        
        if (response) {
        return response;
        } else {
        return null;
        }
    }


    async getReasonsDropDownInfo():Promise<ReasonsDropDownResponse>{
        try{
            const reasonsData: ReasonsDropDown[] = await this.reasonsRepository.createQueryBuilder()
                .select("reasons_id as reasonId, reasons_code as reasonCode, reasons_name as reasonName")
                .where(`is_active=1`)
                .getRawMany();
                if(reasonsData?.length){
                    return new ReasonsDropDownResponse(true, 11108, "Items retrieved successfully", reasonsData);
                }else{
                    return new ReasonsDropDownResponse(false, 99999, "No Data Found");
                }
        }catch(error){
            return error;
        }
    }
}

